import comparateurMargeApi from '@/api/comparateur-marges.api'
import { numtiersCible } from '@/utils/destinataire'

const getDefaultState = () => {
  return {
    unites: [],
    unitesEngrais: [],
    cultures: [],
    adminComparateurMargeByGraine: { typeCulture: null },
    adherentComparateurMarge: {}
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    unites (state) {
      return state.unites
    },
    unitesEngrais (state) {
      return state.unitesEngrais
    },
    cultures (state) {
      return state.cultures
    },
    adminComparateurMargeByGraine (state) {
      return state.adminComparateurMargeByGraine
    },
    adherentComparateurMarge (state) {
      return state.adherentComparateurMarge
    }
  },

  mutations: {
    UPDATE_UNITES (state, unites) {
      state.unites = unites
    },
    UPDATE_UNITES_ENGRAIS (state, unitesEngrais) {
      state.unitesEngrais = unitesEngrais
    },
    UPDATE_ADMIN_COMPARATEUR_MARGE_CULTURES_PRESENTES (state, cultures) {
      state.cultures = cultures
    },
    UPDATE_ADMIN_COMPARATEUR_MARGE_BY_GRAINE (state, adminComparateurMargeByGraine) {
      state.adminComparateurMargeByGraine = adminComparateurMargeByGraine
    },
    UPDATE_ADHERENT_COMPARATEUR_MARGE (state, adherentComparateurMarge) {
      state.adherentComparateurMarge = adherentComparateurMarge
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getAdminComparateurMargeUnites ({ commit }) {
      return comparateurMargeApi.getAdminComparateurMargeUnites()
        .then(response => {
          commit('UPDATE_UNITES', response)
        })
    },
    getAdminComparateurMargeUniteEngrais ({ commit }) {
      return comparateurMargeApi.getAdminComparateurMargeUniteEngrais()
        .then(response => {
          commit('UPDATE_UNITES_ENGRAIS', response)
        })
    },
    createOrUpdateAdminComparateurMargeUnitesEngrais ({ dispatch }, uniteEngrais) {
      let promiseUpdate
      if (uniteEngrais.id) {
        promiseUpdate = comparateurMargeApi.updateAdminComparateurMargeUniteEngrais(uniteEngrais)
      } else {
        promiseUpdate = comparateurMargeApi.createAdminComparateurMargeUniteEngrais(uniteEngrais)
      }
      return promiseUpdate.then(() => dispatch('getAdminComparateurMargeUniteEngrais'))
    },
    deleteAdminComparateurMargeUnitesEngrais ({ dispatch }, id) {
      return comparateurMargeApi.deleteAdminComparateurMargeUniteEngrais(id)
        .then(() => dispatch('getAdminComparateurMargeUniteEngrais'))
    },
    getComparateurMargeCulturesPresentes ({ commit }, isAdmin) {
      return comparateurMargeApi.getComparateurMargeCulturesPresentes(isAdmin)
        .then(response => {
          commit('UPDATE_ADMIN_COMPARATEUR_MARGE_CULTURES_PRESENTES', response)
          return response
        })
    },
    getAdminComparateurMargeByGraine ({ dispatch, commit }, id) {
      return comparateurMargeApi.getAdminComparateurMargeByGraine(id)
        .then(response => {
          dispatch('getComparateurMargeCulturesPresentes', true)
          commit('UPDATE_ADMIN_COMPARATEUR_MARGE_BY_GRAINE', response)
          return response
        })
    },
    createOrUpdateAdminComparateurParametreMarge ({ dispatch }, parametre) {
      let promiseUpdate
      if (parametre.id) {
        promiseUpdate = comparateurMargeApi.updateAdminComparateurParametreMarge(parametre)
      } else {
        promiseUpdate = comparateurMargeApi.createAdminComparateurParametreMarge(parametre)
      }
      return promiseUpdate.then(() => dispatch('getAdminComparateurMargeByGraine', parametre.typeCulture.id))
    },
    deleteAdminComparateurParametreMarge ({ dispatch }, parametre) {
      return comparateurMargeApi.deleteAdminComparateurParametreMarge(parametre.id)
        .then(() => dispatch('getAdminComparateurMargeByGraine', parametre.typeCulture.id))
    },
    updateAdminComparateurIndicateurNonChiffreMarge ({ dispatch }, indicateurNonChiffre) {
      return comparateurMargeApi.updateAdminComparateurIndicateurNonChiffreMarge(indicateurNonChiffre)
        .then(() => dispatch('getAdminComparateurMargeByGraine', indicateurNonChiffre.typeCulture.id))
    },
    getAdherentComparateurMarge ({ rootGetters, commit }, culturesSelected) {
      const username = numtiersCible(rootGetters)
      return comparateurMargeApi.getAdherentComparateurMarge(username, culturesSelected)
        .then(response => {
          commit('UPDATE_ADHERENT_COMPARATEUR_MARGE', response)
        })
    },
    updateAdherentComparateurMarge ({ dispatch }, params) {
      return comparateurMargeApi.updateAdherentComparateurMarge(params.parametre).then(() => dispatch('getAdherentComparateurMarge', params.cultures))
    },
    deleteAdherentComparateurMarge ({ rootGetters, commit }) {
      // ATTENTION - ecart volontairement conserve, a trancher avec le metier.
      // Contrairement a getAdherentComparateurMarge ci-dessus (qui utilise
      // numtiersCible), cette suppression n'a pas de repli sur l'utilisateur
      // connecte : sans adherent selectionne, elle part avec username = null.
      // Corriger revient a faire FONCTIONNER la suppression dans ce cas -
      // ce qui est probablement l'intention, mais doit etre valide avant.
      let username = rootGetters['adherent/numtiers']
      return comparateurMargeApi.deleteAdherentComparateurMarge(username)
        .then(() => commit('UPDATE_ADHERENT_COMPARATEUR_MARGE', null))
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
